<template>
  <div class="changepawd">
    <crumbs>
      <i class="icon-stack"></i>
      <span class="text">{{sidebarListLan.changepswd.text}}</span>
    </crumbs>
    <div class="content">
      <div class="panel">
        <div class="form-horizontal">
          <mimput class="col-lg-8 col-lg-offset-2" :col="12" :label='sidebarListLan.changepswd.content.account'>
            <input name='user_name' type="text" class="form-control col-lg-12" v-model='user.user_name' ref="user_name">
          </mimput>
          <mimput class="col-lg-8 col-lg-offset-2" :col="12" :label='sidebarListLan.changepswd.content.passworda' :errBool="errors.has('oldpaswd')" :errTexrt="sidebarListLan.changepswd.content.errora">
            <input name='oldpaswd' @keyup.enter="changeOk" type="password" class="form-control col-lg-12" v-validate="'required|'" v-model='fromVal.oldpaswd'>
          </mimput>
          <mimput class="col-lg-8 col-lg-offset-2" :col="12" :label='sidebarListLan.changepswd.content.passwordb' :errBool="errors.has('newpaswd')" :errTexrt="sidebarListLan.changepswd.content.errorc">
            <input name='newpaswd' @keyup.enter="changeOk" type="password" class="form-control col-lg-12" v-validate="'required|min:6'" v-model='fromVal.newpaswd':placeholder="sidebarListLan.changepswd.content.passwordb">
          </mimput>
          <mimput class="col-lg-8 col-lg-offset-2" :col="12" :label='sidebarListLan.changepswd.content.passwordc' :errBool="errors.has('okpaswd')" :errTexrt="sidebarListLan.changepswd.content.errorb">
            <input name='okpaswd' @keyup.enter="changeOk" type="password" class="form-control col-lg-12" v-validate="'required|min:6'" v-model='fromVal.okpaswd':placeholder="sidebarListLan.changepswd.content.passwordc">
          </mimput>
          <mimput class="col-lg-8 col-lg-offset-2" :col="12" >
            <button class="btn bg-teal" @click="changeOk">{{sidebarListLan.changepswd.content.okChange}}</button>
          </mimput>
          <Modal v-model="modalShow" class="modal-content-j" size="sm" :footer="false" :header="false" :backdrop="!modalLink">
            <div :class="(modalBool?'color-green':'color-red')">
              <i class="glyphicon" :class="(modalBool?'glyphicon-ok':'glyphicon-warning-sign')"></i>
              {{modalBool?sidebarListLan.changepswd.content.succeed:sidebarListLan.changepswd.content.err}}
            </div>
          </Modal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import crumbs from 'components/crumbs'
  import mimput from 'components/mimput'
  import {URL_CHANGEPWD} from '../api/api.js'

  export default {
    name: "changepswd",
    mixins: [
      require("common/mixin/base.js").base({sidebarListLan:"sidebarList"}),
      require("common/mixin/modal.js").modal()
    ],
    data() {
      return {
        fromVal: {
          oldpaswd: "",
          newpaswd: "",
          okpaswd: "",
        },
        modalBool: false,
        user: JSON.parse(sessionStorage.user)
      }
    },
    mounted() {
      this.$refs.user_name.disabled = true
    },
    methods: {
      changeOk() {
        //确认修改前，判断所有的框是否都已校验成功
        this.$validator.validateAll().then((result) => {
          if (result) {
            //校验成功
              let that = this;
//              let uid = JSON.parse(sessionStorage.user).user_id
              //发送请求
              that.$http.post(URL_CHANGEPWD, {      //   server +'user/changemsg'
                newpasswd: that.fromVal.newpaswd, //新密码
                oldpasswd: that.fromVal.oldpaswd
              }).then((res) => {
                let data = res.data;
                if (data.code == 460) {
                  this.modalBool = false
                } else {

                  this.modalBool = true;
//                  that.$router.push({
//                    path: "accountList"
//                  });
                }
                this.modalShow = true
              })
          } else {
            this.modalShow = true
          }
        });
      }
    },
    components: {
      crumbs,
      mimput
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
  .changepawd {
    .glyphicon {
      margin-right: 10px;
    }
    .help {
      position: absolute;
      margin: -3px 0px 0px 5px

    }
  }


  .control-label {
    padding-left: 5%;
  }



  .form-horizontal {
    padding: 20px 20px 0 20px;
    overflow:hidden;
  }

  .hint {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    height: 100%;
    background: #000;
    text-align: center;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    opacity: 0.5;
  }

  .tips {
    padding: 17px;
    width: 33.3%;
    background-color: #fff;
    text-align: center;
    border-radius: 5px;
    -webkit-animation: show 0.3s;
    animation: show 0.3s;
    min-width: 100px;
    border: 2px solid #000;
  }

  .tips .btn {
    padding: 10px 32px;
    margin-top: 26px;
    border-radius: 5px;
    background-color: #8cd4f5;
    font-size: 17px;
    font-weight: 500;
  }

  .reminder, .win {
    color: red;
  }

  .help {
    color: #ea1c0d;
  }
</style>



// WEBPACK FOOTER //
// changepswd.vue?76e839b5